export default function PHP_get_client_info() {
  return (
    <div>
      <h1>PHP_get_client_info</h1>
    </div>
  );
}
